/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable no-useless-escape */
const urlsRegex = /https:\/\/(?:\w+\.)?mercadoli(?:v|b)re\.(?:co(?:m?)|cl)(?:\.\w{1,2})\/(?:[\.,/]?[\w\-#=%&?!@:\[\]]+)+/gim;

export { urlsRegex as urls };
